<ion-header>
  <ion-toolbar>
    <ion-title class="px-2 py-2">Order Review</ion-title>
    <ion-buttons slot="end">
      <ion-button class="ion-text-capitalize btn-design" (click)="onSave()" [disabled]="isDisabled">
        Save
      </ion-button>
      <ion-button class="ion-text-capitalize btn-design" (click)="onClose()">
        Close
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="reviewForm" class="smartdine-form">
    <ion-item lines="none">
      <ion-label position="stacked">
        Customer Name <span class="required-star">*</span>
      </ion-label>
      <ion-input type="text" placeholder="Customer Name" formControlName="name"></ion-input>
    </ion-item>
    <small class="error-text" *ngIf="reviewForm.get('name')?.invalid && reviewForm.get('name')?.touched">
      Customer Name is required.
    </small>

    <ion-item lines="none">
      <ion-label position="stacked">
        Mobile Number <span class="required-star">*</span>
      </ion-label>
      <ion-input type="tel" placeholder="10-digit number" formControlName="phoneNumber"></ion-input>
    </ion-item>
    <small class="error-text" *ngIf="reviewForm.get('phoneNumber')?.invalid && reviewForm.get('phoneNumber')?.touched">
      Enter a valid 10-digit number.
    </small>

    <ion-item lines="none">
      <ion-label position="stacked">Overall Rating</ion-label>
      <review-star
        class="rating-star"
        [rating]="overallRating"
        [fieldName]="'overview'"
        [isDisabled]="isDisabled"
        (ratingChange)="onRatingChange($event)">
      </review-star>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Food Quality</ion-label>
      <review-star
        class="rating-star"
        [rating]="foodRating"
        [fieldName]="'food'"
        [isDisabled]="isDisabled"
        (ratingChange)="onRatingChange($event)">
      </review-star>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Service Level</ion-label>
      <review-star
        class="rating-star"
        [rating]="serviceRating"
        [fieldName]="'service'"
        [isDisabled]="isDisabled"
        (ratingChange)="onRatingChange($event)">
      </review-star>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Ambience Rating</ion-label>
      <review-star
        class="rating-star"
        [rating]="ambianceRating"
        [fieldName]="'ambiance'"
        [isDisabled]="isDisabled"
        (ratingChange)="onRatingChange($event)">
      </review-star>
    </ion-item>

    <ion-item lines="none">
      <ion-label position="stacked">Comments</ion-label>
      <ion-textarea
        placeholder="Your feedback..."
        formControlName="comments">
      </ion-textarea>
    </ion-item>
  </form>
</ion-content>
